<template>
  <div class="container mb-4">
  </div>
</template>

<script>
export default {
  name: 'InvoiceRules'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Invoices/InvoiceRules.vue